import React, { Dispatch, SetStateAction } from "react";
import { Flex, Text, TouchableOpacity } from "@atoms";

// == Types ================================================================

interface IProps {
  activeTab: FUNDS_TABS_ENUM;
  setTab: Dispatch<SetStateAction<FUNDS_TABS_ENUM>>;
}

// == Constants ============================================================

export enum FUNDS_TABS_ENUM {
  EARNINGS = "EARNINGS",
  WITHDRAWALS = "WITHDRAWALS",
}

// == Component ============================================================

export function FundsPageTabs({ activeTab, setTab }: IProps) {
  return (
    <Flex width="100%">
      <TouchableOpacity
        borderBottom={
          activeTab === FUNDS_TABS_ENUM.EARNINGS ? "fundsTabActive" : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setTab(FUNDS_TABS_ENUM.EARNINGS)}
      >
        <Text color={activeTab === FUNDS_TABS_ENUM.EARNINGS ? "#2c9895" : ""}>Earnings</Text>
      </TouchableOpacity>
      <TouchableOpacity
        borderBottom={
          activeTab === FUNDS_TABS_ENUM.WITHDRAWALS ? "fundsTabActive" : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setTab(FUNDS_TABS_ENUM.WITHDRAWALS)}
      >
        <Text color={activeTab === FUNDS_TABS_ENUM.WITHDRAWALS ? "#2c9895" : ""}>Withdrawals</Text>
      </TouchableOpacity>
    </Flex>
  );
}

// == Styles ===============================================================
